import * as tslib_1 from "tslib";
import { updateUserConfiguration } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveLinkPreviewOption')(function saveLinkPreviewOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.LinkPreviewEnabled = optionState.isEnabled;
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'LinkPreviewEnabled',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.LinkPreviewEnabled,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveLinkPreviewOption.js.map